import React from 'react';
import { WavyLink } from "react-wavy-transitions";
import { useAuth } from '../../Context/Context';

const Services = () => {
    const {useRef} = React;
    let ref_web = useRef(null);
    const { direction } = useAuth();


    const hover = e => {
        if (e.target.id === "web_1" || e.target.id === "erp_1" || e.target.id === "commerce_1" || e.target.id === "branding_1") {
            e.target.parentNode.parentNode.id = "activo";
        }
    }

    const hoverOut = e => {
        if (e.target.id === "web_1" || e.target.id === "erp_1" || e.target.id === "commerce_1" || e.target.id === "branding_1") {
            e.target.parentNode.parentNode.id = "inactivo";
        }
    }

    return (
        <div className='container'>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                style={{width:"100%", height:"310px"}}
                viewBox="0 0 1604.068 242.133"
            >
                <defs>
                    <clipPath id="clip-path">
                        <path
                            id="Trazado_146"
                            data-name="Trazado 146"
                            d="M313,116.379h27.767v86.679H313Zm0,0"
                            transform="translate(-313 -116.379)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-2">
                        <path
                            id="Trazado_148"
                            data-name="Trazado 148"
                            d="M199,116.379h61.988v86.679H199Zm0,0"
                            transform="translate(-199 -116.379)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-3">
                        <path
                            id="Trazado_155"
                            data-name="Trazado 155"
                            d="M116.379,318h86.678v26.116H116.379Zm0,0"
                            transform="translate(-116.379 -318)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-4">
                        <path
                            id="Trazado_157"
                            data-name="Trazado 157"
                            d="M116.379,116.379h86.678v86.679H116.379Zm0,0"
                            transform="translate(-116.379 -116.379)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-5">
                        <path
                            id="Trazado_160"
                            data-name="Trazado 160"
                            d="M210,74.422h59.75v46.854H210Zm0,0"
                            transform="translate(-210 -74.422)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-6">
                        <path
                            id="Trazado_162"
                            data-name="Trazado 162"
                            d="M104,198h78.881v70.485H104Zm0,0"
                            transform="translate(-104 -198)"
                            fill="#797979"
                        />
                    </clipPath>
                    <clipPath id="clip-path-7">
                        <path
                            id="Trazado_1292"
                            data-name="Trazado 1292"
                            d="M163,43.488h58.623v86.676H163Zm0,0"
                            transform="translate(-163 -43.488)"
                            fill="#797979"
                        />
                    </clipPath>
                    {/* inicio - color boton */}
                    <filter
                        id="Background"
                        x="609.662"
                        y="169.133"
                        width="358.553"
                        height={163}
                        filterUnits="userSpaceOnUse"
                    >
                    <feOffset dx={-10} dy={15} input="SourceAlpha" />
                    <feGaussianBlur stdDeviation={15} result="blur" />
                    <feFlood floodOpacity="0.302" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                    </filter>
                    {/* fin - color boton */}
                </defs>
                <g
                    id="Grupo_199"
                    data-name="Grupo 199"
                    transform="translate(-156.81 -933.867)"
                >
                    <a onMouseOver={hover} onMouseOut={hoverOut} href="/servicio/pagina-web">
                        <g id="_3" ref={ref_web} className='inactivo' data-name={3} transform="translate(384.322 933.867)">
                        <path
                            id="Trazado_143"
                            data-name="Trazado 143"
                            d="M238.5,231.208H173.024a1.66,1.66,0,1,1,0-3.321H238.5a1.66,1.66,0,0,1,0,3.321Zm0,0"
                            transform="translate(-163.111 -211.15)"
                            fill="#797979"
                        />
                        <path
                            id="Trazado_144"
                            data-name="Trazado 144"
                            d="M248.054,563.592H184.082a1.661,1.661,0,0,1,0-3.323h63.972a1.661,1.661,0,0,1,0,3.323Zm0,0"
                            transform="translate(-172.509 -493.645)"
                            fill="#797979"
                        />
                        <g
                            id="Grupo_10"
                            data-name="Grupo 10"
                            transform="translate(29.511 0)"
                            clipPath="url(#clip-path)"
                        >
                            <path
                            id="Trazado_145"
                            data-name="Trazado 145"
                            d="M326.827,202.988c-2.473,0-6.081-1.678-9.231-9.669-2.24-5.685-3.824-13.373-4.58-22.229a1.66,1.66,0,0,1,1.654-1.8h24.3a1.659,1.659,0,0,1,1.655,1.8c-.755,8.858-2.339,16.545-4.577,22.229C332.909,201.31,329.3,202.988,326.827,202.988ZM316.494,172.61a76.728,76.728,0,0,0,4.193,19.492c1.9,4.807,4.133,7.565,6.141,7.565s4.245-2.758,6.138-7.565a76.773,76.773,0,0,0,4.19-19.492Zm22.487-22.628H314.672a1.662,1.662,0,0,1-1.655-1.8c.755-8.86,2.34-16.55,4.58-22.236,3.148-7.992,6.757-9.67,9.231-9.67s6.083,1.678,9.228,9.67c2.228,5.66,3.807,13.3,4.567,22.115a1.741,1.741,0,0,1,.021.261A1.663,1.663,0,0,1,338.981,149.982Zm-22.487-3.323h20.662a76.753,76.753,0,0,0-4.19-19.5c-1.892-4.807-4.129-7.565-6.138-7.565s-4.245,2.757-6.141,7.565A76.784,76.784,0,0,0,316.494,146.659Zm0,0"
                            transform="translate(-313.009 -116.289)"
                            fill="#797979"
                            />
                        </g>
                        <g
                            id="Grupo_11"
                            data-name="Grupo 11"
                            transform="translate(12.401 0)"
                            clipPath="url(#clip-path-2)"
                        >
                            <path
                            id="Trazado_147"
                            data-name="Trazado 147"
                            d="M230.017,202.995c-7.227,0-14.042-3.159-19.707-9.135-5.386-5.68-9.353-13.7-11.172-22.571a1.661,1.661,0,0,1,1.626-1.994h58.5a1.663,1.663,0,0,1,1.628,1.994c-1.819,8.874-5.787,16.89-11.171,22.571C244.055,199.836,237.241,202.995,230.017,202.995Zm-27.175-30.378c3.952,16.031,14.917,27.057,27.175,27.057s23.218-11.025,27.17-27.057Zm56.425-22.628h-58.5a1.662,1.662,0,0,1-1.626-2c1.819-8.878,5.786-16.895,11.172-22.577,5.664-5.976,12.479-9.135,19.707-9.135s14.038,3.16,19.7,9.135c5.361,5.656,9.316,13.627,11.147,22.457a1.642,1.642,0,0,1,.063.453A1.66,1.66,0,0,1,259.267,149.988Zm-56.425-3.323h54.345c-3.951-16.035-14.915-27.062-27.17-27.062S206.793,130.631,202.842,146.666Zm0,0"
                            transform="translate(-199.088 -116.296)"
                            fill="#797979"
                            />
                        </g>
                        <path
                            id="Trazado_149"
                            data-name="Trazado 149"
                            d="M167.905,374.665l1.231,3.681.024.065a7.608,7.608,0,0,1,.347,1.239c.032-.176.075-.36.127-.553s.129-.44.226-.743l1.255-3.688h3.044l-3.5,8.336h-2.081l-1.239-3.773c-.064-.215-.124-.43-.176-.647s-.1-.434-.144-.648a11.608,11.608,0,0,1-.324,1.246l-.015.059L165.454,383h-2.081l-3.483-8.335h3.029l1.246,3.688c.093.269.167.505.223.706a5.907,5.907,0,0,1,.131.59,8.925,8.925,0,0,1,.323-1.147c.022-.066.038-.116.05-.149l1.238-3.688Zm0,0"
                            transform="translate(-153.36 -335.897)"
                            fill="#797979"
                        />
                        <path
                            id="Trazado_150"
                            data-name="Trazado 150"
                            d="M258.455,374.665l1.23,3.681.023.065a7.42,7.42,0,0,1,.347,1.239c.033-.176.077-.36.128-.553s.128-.44.227-.743l1.254-3.688h3.045L261.21,383h-2.08l-1.238-3.773c-.067-.215-.127-.43-.178-.647s-.1-.434-.145-.648a10.992,10.992,0,0,1-.321,1.246l-.017.059L256,383h-2.079l-3.485-8.335h3.031l1.245,3.688c.094.269.169.505.223.706a5.931,5.931,0,0,1,.134.59,8.648,8.648,0,0,1,.321-1.147c.022-.066.039-.116.049-.149l1.238-3.688Zm0,0"
                            transform="translate(-230.316 -335.897)"
                            fill="#797979"
                        />
                        <path
                            id="Trazado_151"
                            data-name="Trazado 151"
                            d="M349.032,374.665l1.228,3.681.026.065a7.531,7.531,0,0,1,.346,1.239q.048-.264.127-.553c.053-.193.127-.44.227-.743l1.254-3.688h3.045l-3.5,8.336h-2.08l-1.238-3.773c-.066-.215-.124-.43-.178-.647s-.1-.434-.145-.648a11.1,11.1,0,0,1-.321,1.246l-.018.059L346.579,383H344.5l-3.483-8.335h3.029l1.245,3.688c.094.269.169.505.223.706a5.93,5.93,0,0,1,.134.59,8.548,8.548,0,0,1,.32-1.147c.023-.066.039-.116.051-.149l1.239-3.688Zm0,0"
                            transform="translate(-307.299 -335.897)"
                            fill="#797979"
                        />
                        <path
                            id="Trazado_152"
                            data-name="Trazado 152"
                            d="M432.289,411.791a1.616,1.616,0,0,1,.473-1.18,1.6,1.6,0,0,1,1.177-.478,1.628,1.628,0,0,1,1.2.478,1.6,1.6,0,0,1,.478,1.18,1.655,1.655,0,0,1-1.674,1.676,1.579,1.579,0,0,1-1.173-.487A1.636,1.636,0,0,1,432.289,411.791Zm0,0"
                            transform="translate(-384.873 -366.042)"
                            fill="#797979"
                        />
                        <path
                            id="Trazado_153"
                            data-name="Trazado 153"
                            d="M497.061,416.34H475.47a1.66,1.66,0,1,1,0-3.321h21.592a1.66,1.66,0,1,1,0,3.321Zm0,0"
                            transform="translate(-420.161 -368.496)"
                            fill="#797979"
                        />
                        <g
                            id="Grupo_12"
                            data-name="Grupo 12"
                            transform="translate(0 30.262)"
                            clipPath="url(#clip-path-3)"
                        >
                            <path
                            id="Trazado_154"
                            data-name="Trazado 154"
                            d="M199.965,344.67H119.679a1.66,1.66,0,0,1-1.6-1.212,43.327,43.327,0,0,1-1.568-9.652c0-.026,0-.053,0-.079v-4.064c0-.026,0-.053,0-.079a43.067,43.067,0,0,1,1.569-9.653,1.659,1.659,0,0,1,1.6-1.211h80.285a1.661,1.661,0,0,1,1.6,1.212,43.74,43.74,0,0,1,0,23.524A1.666,1.666,0,0,1,199.965,344.67Zm-79.006-3.322h77.724a40.478,40.478,0,0,0,0-19.306H120.959a39.791,39.791,0,0,0-1.125,7.661v3.983A39.925,39.925,0,0,0,120.959,341.348Zm0,0"
                            transform="translate(-116.492 -318.611)"
                            fill="#797979"
                            />
                        </g>
                        <g
                            id="Grupo_13"
                            data-name="Grupo 13"
                            transform="translate(0 0)"
                            clipPath="url(#clip-path-4)"
                        >
                            <path
                            id="Trazado_156"
                            data-name="Trazado 156"
                            d="M159.542,202.995A43.35,43.35,0,1,1,190.2,190.3,43.078,43.078,0,0,1,159.542,202.995Zm0-83.391a40.035,40.035,0,1,0,40.031,40.038A40.082,40.082,0,0,0,159.542,119.6Zm0,0"
                            transform="translate(-116.213 -116.296)"
                            fill="#797979"
                            />
                        </g>
                        </g>
                        <text
                            id="Páginas_web"
                            data-name="Páginas web"
                            transform="translate(427.662 1077)"
                            fill="#797979"
                            fontSize={25}
                            fontFamily="HindMadurai-Regular"
                            letterSpacing="0.005em"
                        >
                            <tspan id="web_1" x="-69.027" y={0}>
                                Páginas web
                            </tspan>
                        </text>
                    </a>
                    <a onMouseOver={hover} onMouseOut={hoverOut} href="/servicio/sistemas-empresariales">
                        <g id="_4" data-name={4} transform="translate(737.102 933.867)">
                        <path
                            id="Trazado_158"
                            data-name="Trazado 158"
                            d="M396.88,605.722a1.288,1.288,0,1,0-1.235-1.338A1.343,1.343,0,0,0,396.88,605.722Zm0,0"
                            transform="translate(-357.43 -533.868)"
                            fill="#797979"
                        />
                        <g
                            id="Grupo_14"
                            data-name="Grupo 14"
                            transform="translate(13.889 0)"
                            clipPath="url(#clip-path-5)"
                        >
                            <path
                            id="Trazado_159"
                            data-name="Trazado 159"
                            d="M260.613,77h5.557l-28.815,32.221-11.526-8.03a1.2,1.2,0,0,0-1.75.309l-13.069,17.6a1.332,1.332,0,0,0,.309,1.853,1.106,1.106,0,0,0,.823.206,1.267,1.267,0,0,0,1.029-.515l12.349-16.677L236.84,112a1.3,1.3,0,0,0,1.749-.206l29.33-32.942v4.735a1.19,1.19,0,0,0,1.235,1.236,1.252,1.252,0,0,0,1.235-1.236V75.657a1.251,1.251,0,0,0-1.235-1.235H260.51a1.252,1.252,0,0,0-1.235,1.235A1.439,1.439,0,0,0,260.613,77Zm0,0"
                            transform="translate(-210.662 -74.422)"
                            fill="#797979"
                            />
                        </g>
                        <g
                            id="Grupo_15"
                            data-name="Grupo 15"
                            transform="translate(0 16.193)"
                            clipPath="url(#clip-path-6)"
                        >
                            <path
                            id="Trazado_161"
                            data-name="Trazado 161"
                            d="M183.092,202.051a3.45,3.45,0,0,0-3.4-3.5H169.2a1.251,1.251,0,0,0-1.235,1.235,1.328,1.328,0,0,0,1.235,1.236h10.394a.84.84,0,0,1,.823.926v44.78h-4.425V209.154a1.252,1.252,0,0,0-1.235-1.235h-7.409a1.252,1.252,0,0,0-1.235,1.235v37.677h-5.557V232.419a1.252,1.252,0,0,0-1.235-1.236H151.7a1.252,1.252,0,0,0-1.235,1.236v14.412h-5.558V228.1a1.252,1.252,0,0,0-1.235-1.236h-7.41a1.252,1.252,0,0,0-1.235,1.236v18.736h-5.558V238.8a1.251,1.251,0,0,0-1.235-1.235h-7.513a1.252,1.252,0,0,0-1.235,1.235v8.03H106.835v-5.456h6.689a1.252,1.252,0,0,0,1.235-1.235,1.329,1.329,0,0,0-1.235-1.236h-6.689v-5.147h6.689a1.252,1.252,0,0,0,1.235-1.235,1.329,1.329,0,0,0-1.235-1.236h-6.689v-5.147h6.689a1.252,1.252,0,0,0,1.235-1.235,1.329,1.329,0,0,0-1.235-1.236h-6.689v-5.147h6.689a1.252,1.252,0,0,0,1.235-1.235,1.329,1.329,0,0,0-1.235-1.236h-6.689V210.9h6.689a1.235,1.235,0,0,0,0-2.471h-6.689v-5.868a.908.908,0,0,1,.823-.926h47.134a1.251,1.251,0,0,0,1.235-1.235,1.328,1.328,0,0,0-1.235-1.236H107.761a3.386,3.386,0,0,0-3.4,3.5l-.1,52.089a4.221,4.221,0,0,0,3.911,4.015h25.522c0,1.853,0,4.941-.1,5.661a3.106,3.106,0,0,1-2.161,2.059h-3.91a1.252,1.252,0,0,0-1.235,1.235,1.329,1.329,0,0,0,1.235,1.236h32.417a1.252,1.252,0,0,0,1.235-1.236,1.328,1.328,0,0,0-1.235-1.235h-4.116a2.663,2.663,0,0,1-1.955-2.059c-.1-.721-.1-3.809-.206-5.661H179.8c2.058,0,3.293-1.956,3.293-3.912Zm-2.47,52.81c0,.618-.309,1.338-.721,1.338H108.07a1.641,1.641,0,0,1-1.338-1.441v-5.25h73.787v5.353Zm0,0"
                            transform="translate(-104.227 -198.479)"
                            fill="#797979"
                            />
                        </g>
                        </g>
                        <text
                            id="Sistemas_ERP"
                            data-name="Sistemas ERP"
                            transform="translate(776.543 1077)"
                            fill="#797979"
                            fontSize={25}
                            fontFamily="HindMadurai-Regular"
                            letterSpacing="0.005em"
                        >
                            <tspan id="erp_1" x="-73.087" y={0}>
                                Sistemas ERP
                            </tspan>
                        </text>
                    </a>
                    <a onMouseOver={hover} onMouseOut={hoverOut} href="/servicio/e-commerce">
                        <g id="_1" data-name={1} transform="translate(1082.084 933.869)">
                            <path
                                id="Trazado_133"
                                data-name="Trazado 133"
                                d="M383.523,404.332c-1.54-1.866-4.011-2.252-7.253-2.252H342.649c-1.51,0-1.809-.639-1.809-1.669,0-1.144,1.3-1.451,1.612-1.514H375A3.2,3.2,0,0,0,378,396.538l5.4-22.258a2.367,2.367,0,0,0-.412-2.027,2.342,2.342,0,0,0-1.872-.875H337.091l-.857-3.5a3.207,3.207,0,0,0-3-2.359h-8.55a1.147,1.147,0,0,0,0,2.293h8.55a.916.916,0,0,1,.777.609l6.969,28.549a3.683,3.683,0,0,0-2.427,3.44c0,2.478,1.537,3.959,4.1,3.959h33.625c3.107,0,4.647.4,5.483,1.419a1.142,1.142,0,0,0,.887.418,1.121,1.121,0,0,0,.725-.26A1.152,1.152,0,0,0,383.523,404.332ZM367.62,381.8l-.862,6.689H352.1l-.916-6.689Zm-16.746-2.291-.788-5.807,18.576.03-.746,5.781H350.874Zm26.722,8.982h-8.527l.863-6.689h9.279Zm-11.133,2.29-.749,5.829H353.2l-.794-5.829Zm-16.678-2.29h-8.521l-1.633-6.689h9.243Zm.311,2.29.8,5.829h-7.647l-1.427-5.829Zm24.9,5.829h-6.969l.749-5.829h8.262L375.771,396A.907.907,0,0,1,375,396.607Zm6.172-22.864-1.4,5.763h-9.542l.74-5.778Zm-33.4-.048.791,5.808h-9.488l-1.424-5.826Zm0,0"
                                transform="translate(-288.275 -329.092)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_134"
                                data-name="Trazado 134"
                                d="M433.116,652.531a5.217,5.217,0,1,0,5.211,5.214A5.218,5.218,0,0,0,433.116,652.531Zm0,7.068a1.854,1.854,0,1,1,1.853-1.854A1.854,1.854,0,0,1,433.116,659.6Zm0,0"
                                transform="translate(-378.164 -576.288)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_135"
                                data-name="Trazado 135"
                                d="M668.012,652.531a5.217,5.217,0,1,0,5.214,5.214A5.218,5.218,0,0,0,668.012,652.531Zm0,7.068a1.854,1.854,0,1,1,1.853-1.854A1.85,1.85,0,0,1,668.012,659.6Zm0,0"
                                transform="translate(-580.476 -576.288)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_136"
                                data-name="Trazado 136"
                                d="M326.606,413.205a15.665,15.665,0,0,0,2.985-4.079l-2.11-8.648H320.6a4.04,4.04,0,0,1-1.8-.436,5.975,5.975,0,0,0,.573,1.033C323.612,407.141,321.051,418.652,326.606,413.205Zm0,0"
                                transform="translate(-284.197 -358.826)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_137"
                                data-name="Trazado 137"
                                d="M116.742,174.757a34.517,34.517,0,0,1-14,.887c-2.57-3.108-4.474-5.664,1.083-9.582,6.722-4.742.451-7.8-4.683-8.546S91.5,145.792,88.624,140.623s-5.244,3.4-7.265,6.292c-1.4,2.009-5.632.508-8.115-.612a34.744,34.744,0,0,1,30.792-39.631c-.737,3.58-1.253,9.5,2.716,11.541,5.838,3,3.188,2.21-5.109,3.75s-4.659,8.4,2.14,12.067c1.609.869,2.268,1.645,2.411,2.4h8.118a6.157,6.157,0,0,1,5.847,4.6l.311,1.266H125.2c2.594-3.183,3.188-10.532-4.017-8.668-8.745,2.266-.1-9.562,4.623-9.606,3.987-.039,6.461-2.556,7.847-5.835a34.742,34.742,0,0,1,8.715,24.109h3.51a38.332,38.332,0,1,0-28.119,35.842A7.088,7.088,0,0,1,116.742,174.757Zm0,0"
                                transform="translate(-69.355 -102.927)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_138"
                                data-name="Trazado 138"
                                d="M164.544,238.2c2.621-2.222,4.749-2.416,5.918-6.614s-5.125-2-7.879.021c-2.427,1.783-3.188,5.975-2.14,8.238S161.929,240.421,164.544,238.2Zm0,0"
                                transform="translate(-147.412 -211.679)"
                                fill="#797979"
                            />
                        </g>
                        <text
                            id="E-commerce"
                            transform="translate(1129.838 1077)"
                            fill="#797979"
                            fontSize={25}
                            fontFamily="HindMadurai-Regular"
                            letterSpacing="0.005em"
                        >
                            <tspan id='commerce_1' x="-69.709" y={0}>
                                E-commerce
                            </tspan>
                        </text>
                    </a>
                    <a onMouseOver={hover} onMouseOut={hoverOut} href="/servicio/branding">
                        <g id="So" transform="translate(1295.762 890.383)">
                            <path
                                id="Trazado_1283"
                                data-name="Trazado 1283"
                                d="M592.753,153.128a.871.871,0,0,0,.781.491.773.773,0,0,0,.347-.087.741.741,0,0,0,.434-.491.891.891,0,0,0-.029-.665,27.51,27.51,0,0,0-2.514-4.364.851.851,0,0,0-.694-.376.974.974,0,0,0-.491.144.841.841,0,0,0-.2,1.185A33.313,33.313,0,0,1,592.753,153.128Zm0,0"
                                transform="translate(-376.005 -91.663)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1284"
                                data-name="Trazado 1284"
                                d="M224.924,74.526a.847.847,0,0,0-.78.925c.058.722.087,1.474.087,2.225a26.893,26.893,0,0,1-5.982,16.907,27.106,27.106,0,0,0-5.953,15.982l-.029.578H198.306l.173-.722c.52-2.283,2.6-9.884,7.283-12.457l.2-.116.2.058a6.009,6.009,0,0,0,1.156.145,5.568,5.568,0,0,0,3.294-1.1,5.471,5.471,0,0,0,2.023-6.243l-1.705-5.2a3.868,3.868,0,0,1,1.416-4.335l4.422-3.208a5.6,5.6,0,0,0-3.294-10.116h-5.491a3.877,3.877,0,0,1-3.7-2.688l-1.706-5.2a5.587,5.587,0,0,0-10.635,0l-1.705,5.2a3.85,3.85,0,0,1-3.7,2.688h-5.491a5.6,5.6,0,0,0-3.294,10.116l4.422,3.208a3.882,3.882,0,0,1,1.416,4.335l-1.705,5.2a5.512,5.512,0,0,0,2.023,6.243,5.653,5.653,0,0,0,3.266,1.069,5.233,5.233,0,0,0,1.156-.116l.2-.058.2.116c4.364,2.37,6.416,8.815,7.283,12.457l.174.722H182.324l-.029-.578a28.216,28.216,0,0,0-6.185-16.271,26.923,26.923,0,0,1,18.121-43.381,27.588,27.588,0,0,1,3.064-.173c.751,0,1.5.029,2.312.087a.849.849,0,0,0,.838-.78.886.886,0,0,0-.781-.925c-.78-.058-1.589-.087-2.37-.087a31.3,31.3,0,0,0-3.266.173,28.66,28.66,0,0,0-19.248,46.156,26.32,26.32,0,0,1,5.809,15.347l.029.433-.433.145a2.975,2.975,0,0,0-2.081,2.832V116.9a3.022,3.022,0,0,0,3.006,3.006h1.474v4.913a3.022,3.022,0,0,0,3.006,3.006h1.185v3.15a3.614,3.614,0,0,0,3.612,3.613h13.843a3.614,3.614,0,0,0,3.613-3.613v-3.15h1.185a3.022,3.022,0,0,0,3.006-3.006V119.9h1.474a3.022,3.022,0,0,0,3.006-3.006v-2.775a2.975,2.975,0,0,0-2.081-2.832l-.433-.145.029-.433a25.562,25.562,0,0,1,5.578-15.058,28.609,28.609,0,0,0,6.359-17.976c0-.809-.029-1.59-.087-2.37A.943.943,0,0,0,224.924,74.526Zm-37.6,21.821a4.011,4.011,0,0,1-2.312-.752A3.807,3.807,0,0,1,183.6,91.26l1.705-5.2a5.553,5.553,0,0,0-2.023-6.242l-4.451-3.266a3.88,3.88,0,0,1,2.283-7.023H186.6a5.587,5.587,0,0,0,5.318-3.873l1.705-5.2a3.89,3.89,0,0,1,7.4,0l1.705,5.2a5.587,5.587,0,0,0,5.318,3.873h5.491a3.88,3.88,0,0,1,2.283,7.023L211.4,79.757A5.556,5.556,0,0,0,209.375,86l1.706,5.2a3.776,3.776,0,0,1-1.416,4.335,3.946,3.946,0,0,1-2.312.751,3.837,3.837,0,0,1-2.254-.751l-4.422-3.208a5.607,5.607,0,0,0-3.294-1.07,5.676,5.676,0,0,0-3.295,1.07l-4.508,3.237A3.681,3.681,0,0,1,187.324,96.347Zm3.815,1.127-.607-.492,4.48-3.237a3.8,3.8,0,0,1,2.283-.752,3.858,3.858,0,0,1,2.283.752l4.48,3.237-.607.492c-2.89,2.341-4.624,6.156-5.607,8.959l-.549,1.618-.549-1.618C195.763,103.63,194.029,99.786,191.138,97.474Zm19.19,27.34a1.3,1.3,0,0,1-1.3,1.3h-2.052a.864.864,0,0,0-.867.838v3.988a1.925,1.925,0,0,1-1.908,1.908H190.387a1.924,1.924,0,0,1-1.907-1.908v-3.15h12.427a.864.864,0,0,0,.867-.838.845.845,0,0,0-.867-.838H185.59a1.3,1.3,0,0,1-1.3-1.3V119.9h26.069v4.913Zm4.48-10.664v2.775a1.3,1.3,0,0,1-1.3,1.3h-32.4a1.3,1.3,0,0,1-1.3-1.3V114.15a1.3,1.3,0,0,1,1.243-1.3h.116l.087.029a1.167,1.167,0,0,0,.2.058H213.1a1.3,1.3,0,0,0,.231-.058l.087-.029h.116A1.308,1.308,0,0,1,214.808,114.15Zm0,0"
                                transform="translate(-4.996 -4.882)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1285"
                                data-name="Trazado 1285"
                                d="M498.341,72.136a24.98,24.98,0,0,1,4.075,2.37.973.973,0,0,0,.491.145.813.813,0,0,0,.694-.376.867.867,0,0,0-.2-1.185,30.776,30.776,0,0,0-4.335-2.515.773.773,0,0,0-.347-.087.9.9,0,0,0-.78.492A.892.892,0,0,0,498.341,72.136Zm0,0"
                                transform="translate(-294.714 -23.763)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1286"
                                data-name="Trazado 1286"
                                d="M493.839,68.414a23.894,23.894,0,0,1,3.988,2.312,1.5,1.5,0,0,0,.838.26,1.431,1.431,0,0,0,.838-2.6,28.29,28.29,0,0,0-4.451-2.572,1.547,1.547,0,0,0-.607-.145,1.442,1.442,0,0,0-.607,2.746ZM494.215,67a.239.239,0,0,1,.231-.145.173.173,0,0,1,.116.029,27.029,27.029,0,0,1,4.248,2.457.273.273,0,0,1,.058.376.214.214,0,0,1-.2.116.222.222,0,0,1-.144-.058,26.187,26.187,0,0,0-4.191-2.4A.261.261,0,0,1,494.215,67Zm0,0"
                                transform="translate(-290.443 -19.521)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1287"
                                data-name="Trazado 1287"
                                d="M587.6,149.568a1.423,1.423,0,0,0,1.3.838,1.173,1.173,0,0,0,.607-.145,1.424,1.424,0,0,0,.694-1.907,31.143,31.143,0,0,0-2.572-4.451,1.426,1.426,0,0,0-1.185-.607,1.508,1.508,0,0,0-.838.26,1.412,1.412,0,0,0-.347,1.994A22.407,22.407,0,0,1,587.6,149.568Zm-1.272-5.058c.058-.029.087-.058.145-.058a.214.214,0,0,1,.2.116,28.478,28.478,0,0,1,2.457,4.249.267.267,0,0,1-.116.347.173.173,0,0,1-.116.029.239.239,0,0,1-.231-.145,27.49,27.49,0,0,0-2.4-4.191A.243.243,0,0,1,586.326,144.511Zm0,0"
                                transform="translate(-371.398 -87.843)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1288"
                                data-name="Trazado 1288"
                                d="M290.439,576.335a.1.1,0,0,0-.058.029H258.793c-.029,0-.058-.029-.116-.029l-.2-.058h-.2a1.877,1.877,0,0,0-1.792,1.878v2.775a1.875,1.875,0,0,0,1.879,1.879h32.4a1.875,1.875,0,0,0,1.878-1.879v-2.775a1.876,1.876,0,0,0-1.792-1.878h-.231Zm1.041,1.85v2.775a.716.716,0,0,1-.723.723H258.388a.692.692,0,0,1-.694-.723v-2.775a.679.679,0,0,1,.665-.694,2.007,2.007,0,0,0,.4.087H290.41a.925.925,0,0,0,.4-.087A.661.661,0,0,1,291.479,578.185Zm0,0"
                                transform="translate(-82.274 -468.916)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1289"
                                data-name="Trazado 1289"
                                d="M295.032,635.34h-1.185v5.491a1.906,1.906,0,0,0,1.907,1.908h15.317a.26.26,0,0,1,0,.52H298.038v3.728a2.486,2.486,0,0,0,2.485,2.486h13.844a2.485,2.485,0,0,0,2.485-2.486V643a.259.259,0,0,1,.26-.26h2.052a1.906,1.906,0,0,0,1.907-1.908V635.34Zm24.884,5.491a.716.716,0,0,1-.723.723h-2.052A1.431,1.431,0,0,0,315.7,643v3.988a1.326,1.326,0,0,1-1.329,1.33H300.553a1.326,1.326,0,0,1-1.329-1.33v-2.543h11.82a1.445,1.445,0,1,0,0-2.89H295.726a.716.716,0,0,1-.723-.723v-4.306h24.883v4.306Zm0,0"
                                transform="translate(-115.161 -520.898)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1290"
                                data-name="Trazado 1290"
                                d="M351.871,425.085c.924-2.717,2.63-6.445,5.4-8.671l1.185-.954-1.243-.9-3.844-2.8a4.547,4.547,0,0,0-2.63-.867,4.348,4.348,0,0,0-2.63.867l-3.844,2.8-1.243.9,1.185.954c2.775,2.254,4.48,5.954,5.4,8.671l1.127,3.237Zm-6.907-9.6,3.844-2.8a3.266,3.266,0,0,1,3.873,0l3.844,2.8c-2.89,2.341-4.711,6.07-5.78,9.22C349.674,421.559,347.854,417.8,344.964,415.49Zm0,0"
                                transform="translate(-158.445 -323.36)"
                                fill="#797979"
                            />
                            <g
                                id="Grupo_150"
                                data-name="Grupo 150"
                                transform="translate(163 43.488)"
                                clipPath="url(#clip-path-7)"
                            >
                                <path
                                id="Trazado_1291"
                                data-name="Trazado 1291"
                                d="M220.752,69.038h-.116a1.455,1.455,0,0,0-1.329,1.56c.058.723.087,1.445.087,2.2a26.4,26.4,0,0,1-5.838,16.532,27.7,27.7,0,0,0-6.1,16.329H194.8c.838-3.671,3.035-9.884,6.994-12.081A6.214,6.214,0,0,0,208.96,85.6l-1.705-5.2a3.278,3.278,0,0,1,1.185-3.671l4.422-3.208a6.18,6.18,0,0,0-3.612-11.185h-5.491a3.261,3.261,0,0,1-3.121-2.283l-1.705-5.2a6.162,6.162,0,0,0-11.734,0l-1.706,5.2a3.288,3.288,0,0,1-3.121,2.283h-5.491a6.18,6.18,0,0,0-3.613,11.185l4.422,3.208a3.236,3.236,0,0,1,1.185,3.671l-1.705,5.2a6.2,6.2,0,0,0,5.867,8.093,6.128,6.128,0,0,0,1.271-.145c4.248,2.312,6.243,8.959,6.965,12.052h-12.6a28.775,28.775,0,0,0-6.3-16.618,26.345,26.345,0,0,1,20.722-42.6c.723,0,1.474.029,2.312.087a1.447,1.447,0,0,0,.115-2.89q-1.214-.086-2.428-.087a32.112,32.112,0,0,0-3.323.173,29.2,29.2,0,0,0-19.652,47.081,25.709,25.709,0,0,1,5.694,15,3.583,3.583,0,0,0-2.485,3.41v2.775a3.583,3.583,0,0,0,3.583,3.584h.867v4.306a3.614,3.614,0,0,0,3.612,3.612H182v2.543a4.193,4.193,0,0,0,4.191,4.191H200.03a4.194,4.194,0,0,0,4.191-4.191V123.43h.607a3.614,3.614,0,0,0,3.612-3.612v-4.306h.867a3.583,3.583,0,0,0,3.584-3.584v-2.775a3.584,3.584,0,0,0-2.486-3.41,24.731,24.731,0,0,1,5.434-14.711,29.281,29.281,0,0,0,6.5-18.352q0-1.214-.087-2.428A1.557,1.557,0,0,0,220.752,69.038Zm-5.867,21.387a26.174,26.174,0,0,0-5.694,15.4l-.029.9.838.26a2.385,2.385,0,0,1,1.677,2.283v2.775a2.4,2.4,0,0,1-2.428,2.4H207.2v5.491a2.443,2.443,0,0,1-2.428,2.428h-1.792v3.728a3.034,3.034,0,0,1-3.035,3.035H186.158a3.034,3.034,0,0,1-3.035-3.035v-3.728h-1.792a2.443,2.443,0,0,1-2.428-2.428v-5.491h-2.052a2.393,2.393,0,0,1-2.4-2.4v-2.775a2.385,2.385,0,0,1,1.677-2.283l.838-.26-.029-.9a27,27,0,0,0-5.925-15.693,28.056,28.056,0,0,1,18.872-45.2,29.683,29.683,0,0,1,3.179-.173q1.17,0,2.341.087a.244.244,0,0,1,.231.289.249.249,0,0,1-.231.231c-.867-.058-1.59-.087-2.341-.087a28.219,28.219,0,0,0-3.121.173,27.522,27.522,0,0,0-18.526,44.335,27.459,27.459,0,0,1,6.07,15.925l.058,1.127h15.231l-.347-1.445c-.867-3.728-3.006-10.347-7.572-12.832l-.376-.2-.433.087a4.259,4.259,0,0,1-1.041.116,5.1,5.1,0,0,1-2.919-.954,4.936,4.936,0,0,1-1.821-5.578l1.705-5.2a4.458,4.458,0,0,0-1.618-5l-4.422-3.208a5,5,0,0,1,2.948-9.046h5.491a4.468,4.468,0,0,0,4.248-3.093l1.706-5.2a5.012,5.012,0,0,1,9.537,0l1.706,5.2a4.468,4.468,0,0,0,4.248,3.093h5.491a4.96,4.96,0,0,1,4.769,3.468,4.867,4.867,0,0,1-1.821,5.578l-4.422,3.208a4.472,4.472,0,0,0-1.618,5l1.705,5.2a4.867,4.867,0,0,1-1.821,5.578,5.013,5.013,0,0,1-2.948.983,4.711,4.711,0,0,1-1.012-.116l-.434-.087-.376.2c-4.913,2.688-7.023,10.52-7.572,12.832l-.318,1.445H208.7l.029-1.127a26.5,26.5,0,0,1,5.838-15.636,27.642,27.642,0,0,0,6.1-17.283c0-.751-.029-1.532-.087-2.283a.421.421,0,0,1,.058-.2.265.265,0,0,1,.2-.087.236.236,0,0,1,.26.231q.086,1.171.087,2.341A28.729,28.729,0,0,1,214.885,90.425Zm0,0"
                                transform="translate(-163.766 -43.488)"
                                fill="#797979"
                                />
                            </g>
                            <path
                                id="Trazado_1293"
                                data-name="Trazado 1293"
                                d="M252.588,152.865a5.034,5.034,0,0,1,5.9,0l4.422,3.237a4.326,4.326,0,0,0,2.6.867,4.7,4.7,0,0,0,2.659-.867,4.4,4.4,0,0,0,1.618-5l-1.705-5.2a4.964,4.964,0,0,1,1.821-5.578l4.422-3.208a4.477,4.477,0,0,0-2.63-8.093H266.2a5.023,5.023,0,0,1-4.768-3.468l-1.706-5.2a4.464,4.464,0,0,0-8.5,0l-1.705,5.2a5.006,5.006,0,0,1-4.769,3.468h-5.491a4.422,4.422,0,0,0-4.248,3.093,4.539,4.539,0,0,0,1.705,4.942l4.422,3.237a4.98,4.98,0,0,1,1.821,5.578l-1.705,5.2a4.389,4.389,0,0,0,1.618,5,4.5,4.5,0,0,0,2.659.867,4.331,4.331,0,0,0,2.6-.867Zm-7.023,2.919a3.413,3.413,0,0,1-1.965-.665,3.209,3.209,0,0,1-1.185-3.671l1.705-5.2a6.172,6.172,0,0,0-2.254-6.907l-4.451-3.237a3.3,3.3,0,0,1,1.936-5.954h5.491a6.114,6.114,0,0,0,5.867-4.277l1.706-5.2a3.275,3.275,0,0,1,6.242,0l1.705,5.2a6.178,6.178,0,0,0,5.867,4.277h5.491a3.3,3.3,0,0,1,1.936,5.954l-4.422,3.208a6.216,6.216,0,0,0-2.254,6.907l1.705,5.2a3.193,3.193,0,0,1-1.185,3.67,3.411,3.411,0,0,1-1.965.665,3.2,3.2,0,0,1-1.907-.636l-4.422-3.237a6.186,6.186,0,0,0-7.283,0L247.5,155.09A3.067,3.067,0,0,1,245.565,155.784Zm0,0"
                                transform="translate(-63.237 -64.926)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1294"
                                data-name="Trazado 1294"
                                d="M493.839,68.414a23.894,23.894,0,0,1,3.988,2.312,1.5,1.5,0,0,0,.838.26,1.431,1.431,0,0,0,.838-2.6,28.29,28.29,0,0,0-4.451-2.572,1.547,1.547,0,0,0-.607-.145,1.442,1.442,0,0,0-.607,2.746Zm-.173-1.647a.87.87,0,0,1,.78-.491.773.773,0,0,1,.347.087,28.191,28.191,0,0,1,4.335,2.515.84.84,0,0,1,.2,1.185.893.893,0,0,1-.694.376.973.973,0,0,1-.491-.144,28.727,28.727,0,0,0-4.075-2.37A.912.912,0,0,1,493.666,66.766Zm0,0"
                                transform="translate(-290.443 -19.521)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1295"
                                data-name="Trazado 1295"
                                d="M587.6,149.568a1.423,1.423,0,0,0,1.3.838,1.173,1.173,0,0,0,.607-.145,1.424,1.424,0,0,0,.694-1.907,31.143,31.143,0,0,0-2.572-4.451,1.426,1.426,0,0,0-1.185-.607,1.508,1.508,0,0,0-.838.26,1.412,1.412,0,0,0-.347,1.994A22.407,22.407,0,0,1,587.6,149.568Zm-1.618-5.549a.975.975,0,0,1,.491-.145.814.814,0,0,1,.694.376,31.1,31.1,0,0,1,2.514,4.365.858.858,0,0,1-.4,1.127.772.772,0,0,1-.346.087.905.905,0,0,1-.781-.491,26.452,26.452,0,0,0-2.37-4.1A.9.9,0,0,1,585.979,144.019Zm0,0"
                                transform="translate(-371.398 -87.843)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1296"
                                data-name="Trazado 1296"
                                d="M299.488,639.951h-.578v4.884a1.3,1.3,0,0,0,1.3,1.3h15.317a.838.838,0,0,1,0,1.677H303.1v3.121a1.924,1.924,0,0,0,1.907,1.907h13.843a1.924,1.924,0,0,0,1.907-1.907v-3.988a.846.846,0,0,1,.867-.838h2.052a1.3,1.3,0,0,0,1.3-1.3v-4.884H299.488Zm24.884,4.913a.716.716,0,0,1-.723.723H321.6a1.431,1.431,0,0,0-1.445,1.445v3.989a1.326,1.326,0,0,1-1.329,1.329H305.008a1.326,1.326,0,0,1-1.329-1.329v-2.543H315.5a1.445,1.445,0,1,0,0-2.89H300.182a.716.716,0,0,1-.723-.723v-4.306h24.883v4.306Zm0,0"
                                transform="translate(-119.617 -524.931)"
                                fill="#797979"
                            />
                            <g
                                id="Grupo_151"
                                data-name="Grupo 151"
                                transform="translate(163 43.488)"
                                clipPath="url(#clip-path-7)"
                            >
                                <path
                                id="Trazado_1297"
                                data-name="Trazado 1297"
                                d="M220.752,69.038h-.116a1.455,1.455,0,0,0-1.329,1.56c.058.723.087,1.445.087,2.2a26.4,26.4,0,0,1-5.838,16.532,27.7,27.7,0,0,0-6.1,16.329H194.8c.838-3.671,3.035-9.884,6.994-12.081A6.214,6.214,0,0,0,208.96,85.6l-1.705-5.2a3.278,3.278,0,0,1,1.185-3.671l4.422-3.208a6.18,6.18,0,0,0-3.612-11.185h-5.491a3.261,3.261,0,0,1-3.121-2.283l-1.705-5.2a6.162,6.162,0,0,0-11.734,0l-1.706,5.2a3.288,3.288,0,0,1-3.121,2.283h-5.491a6.18,6.18,0,0,0-3.613,11.185l4.422,3.208a3.236,3.236,0,0,1,1.185,3.671l-1.705,5.2a6.2,6.2,0,0,0,5.867,8.093,6.128,6.128,0,0,0,1.271-.145c4.248,2.312,6.243,8.959,6.965,12.052h-12.6a28.775,28.775,0,0,0-6.3-16.618,26.345,26.345,0,0,1,20.722-42.6c.723,0,1.474.029,2.312.087a1.447,1.447,0,0,0,.115-2.89q-1.214-.086-2.428-.087a32.112,32.112,0,0,0-3.323.173,29.2,29.2,0,0,0-19.652,47.081,25.709,25.709,0,0,1,5.694,15,3.583,3.583,0,0,0-2.485,3.41v2.775a3.583,3.583,0,0,0,3.583,3.584h.867v4.306a3.614,3.614,0,0,0,3.612,3.612H182v2.543a4.193,4.193,0,0,0,4.191,4.191H200.03a4.194,4.194,0,0,0,4.191-4.191V123.43h.607a3.614,3.614,0,0,0,3.612-3.612v-4.306h.867a3.583,3.583,0,0,0,3.584-3.584v-2.775a3.584,3.584,0,0,0-2.486-3.41,24.731,24.731,0,0,1,5.434-14.711,29.281,29.281,0,0,0,6.5-18.352q0-1.214-.087-2.428A1.557,1.557,0,0,0,220.752,69.038Zm-5.4,21.734a25.488,25.488,0,0,0-5.578,15.058l-.029.433.434.145a2.975,2.975,0,0,1,2.081,2.832v2.775a3.022,3.022,0,0,1-3.006,3.006H207.8V119.9a3.022,3.022,0,0,1-3.005,3.006h-1.185v3.122A3.614,3.614,0,0,1,200,129.644H186.158a3.614,3.614,0,0,1-3.612-3.612V122.91H181.36a3.022,3.022,0,0,1-3.005-3.006V115.02h-1.445a3.022,3.022,0,0,1-3.006-3.006v-2.775a2.975,2.975,0,0,1,2.081-2.832l.434-.145-.029-.433a26.247,26.247,0,0,0-5.809-15.347,28.606,28.606,0,0,1,19.248-46.127,24.3,24.3,0,0,1,3.237-.2c.809,0,1.589.029,2.37.087a.868.868,0,0,1,.781.925.843.843,0,0,1-.809.78c-.867-.058-1.618-.087-2.341-.087A26.921,26.921,0,0,0,166.3,69.731a26.869,26.869,0,0,0,5.578,19.682,28.141,28.141,0,0,1,6.185,16.271l.029.578h13.959l-.174-.722c-.838-3.642-2.89-10.087-7.283-12.457l-.2-.116-.2.058a5.233,5.233,0,0,1-1.156.116,5.653,5.653,0,0,1-3.266-1.069,5.471,5.471,0,0,1-2.023-6.243l1.705-5.2a3.868,3.868,0,0,0-1.416-4.335l-4.451-3.237a5.6,5.6,0,0,1,3.295-10.116h5.491a3.877,3.877,0,0,0,3.7-2.688l1.705-5.2a5.587,5.587,0,0,1,10.635,0l1.705,5.2a3.851,3.851,0,0,0,3.7,2.688h5.491A5.6,5.6,0,0,1,212.6,73.055l-4.422,3.208a3.883,3.883,0,0,0-1.416,4.335l1.706,5.2a5.63,5.63,0,0,1-5.318,7.341A6.284,6.284,0,0,1,202,93l-.2-.058-.2.116c-4.682,2.572-6.763,10.173-7.283,12.457l-.173.723h13.988l.029-.578A27.37,27.37,0,0,1,214.1,89.673a27.064,27.064,0,0,0,5.982-16.907c0-.752-.029-1.5-.087-2.225a.883.883,0,0,1,.2-.636.754.754,0,0,1,.578-.289h.087a.848.848,0,0,1,.838.78c.058.781.087,1.59.087,2.37A29.23,29.23,0,0,1,215.348,90.771Zm0,0"
                                transform="translate(-163.766 -43.488)"
                                fill="#797979"
                                />
                            </g>
                            <path
                                id="Trazado_1299"
                                data-name="Trazado 1299"
                                d="M259.511,155.366a5.673,5.673,0,0,1,3.294,1.07l4.422,3.237a3.837,3.837,0,0,0,2.254.752,4.011,4.011,0,0,0,2.312-.752,3.806,3.806,0,0,0,1.416-4.335l-1.705-5.2a5.555,5.555,0,0,1,2.023-6.242l4.451-3.266A3.88,3.88,0,0,0,275.7,133.6H270.2a5.586,5.586,0,0,1-5.318-3.873l-1.706-5.2a3.889,3.889,0,0,0-7.4,0l-1.706,5.2a5.586,5.586,0,0,1-5.318,3.873h-5.491a3.88,3.88,0,0,0-2.283,7.023l4.422,3.208a5.554,5.554,0,0,1,2.023,6.243l-1.705,5.2a3.791,3.791,0,0,0,1.416,4.335,3.944,3.944,0,0,0,2.312.751,3.838,3.838,0,0,0,2.254-.751l4.422-3.208A6.116,6.116,0,0,1,259.511,155.366Zm-8.064,3.815a3.251,3.251,0,0,1-1.907.664,3.413,3.413,0,0,1-1.965-.664,3.209,3.209,0,0,1-1.185-3.671l1.705-5.2a6.172,6.172,0,0,0-2.254-6.907l-4.451-3.266a3.3,3.3,0,0,1,1.936-5.954h5.491a6.114,6.114,0,0,0,5.867-4.277l1.706-5.2a3.275,3.275,0,0,1,6.242,0l1.705,5.2a6.178,6.178,0,0,0,5.867,4.277H275.7a3.3,3.3,0,0,1,1.936,5.954l-4.422,3.208a6.216,6.216,0,0,0-2.254,6.907l1.705,5.2a3.193,3.193,0,0,1-1.185,3.671,3.411,3.411,0,0,1-1.965.665,3.2,3.2,0,0,1-1.907-.636l-4.422-3.237a6.186,6.186,0,0,0-7.283,0Zm0,0"
                                transform="translate(-67.212 -68.958)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1300"
                                data-name="Trazado 1300"
                                d="M295.368,581.34l-.087.029a.887.887,0,0,1-.231.058H263.433a.885.885,0,0,1-.231-.058l-.087-.029h-.087a1.3,1.3,0,0,0-1.243,1.3v2.775a1.3,1.3,0,0,0,1.3,1.3h32.4a1.3,1.3,0,0,0,1.3-1.3V582.64a1.3,1.3,0,0,0-1.242-1.3Zm.781,1.3v2.775a.716.716,0,0,1-.723.723H263.057a.692.692,0,0,1-.694-.723V582.64a.679.679,0,0,1,.665-.694,2.007,2.007,0,0,0,.4.087h31.646a.925.925,0,0,0,.4-.087A.661.661,0,0,1,296.148,582.64Zm0,0"
                                transform="translate(-86.942 -473.372)"
                                fill="#797979"
                            />
                            <path
                                id="Trazado_1301"
                                data-name="Trazado 1301"
                                d="M357.744,430.321l.549-1.618c.954-2.8,2.717-6.618,5.607-8.959l.607-.491-.636-.463-3.844-2.8a3.844,3.844,0,0,0-4.566,0l-3.844,2.8-.636.463.607.491c2.89,2.341,4.624,6.156,5.607,8.959Zm-5.78-11.012,3.844-2.8a3.266,3.266,0,0,1,3.873,0l3.844,2.8c-2.89,2.341-4.711,6.07-5.78,9.22C356.674,425.379,354.853,421.621,351.963,419.309Zm0,0"
                                transform="translate(-165.445 -327.18)"
                                fill="#797979"
                            />
                        </g>
                        <text
                            id="Branding"
                            transform="translate(1502.074 1077)"
                            fill="#797979"
                            fontSize={25}
                            fontFamily="HindMadurai-Regular"
                            letterSpacing="0.005em"
                        >
                            <tspan id='branding_1' x="-50.206" y={0}>
                                Diseño
                            </tspan>
                        </text>
                    </a>

                    {/* inicio - boton */}
                    {/* <a href="/servicios">
                        <g id="btn-primary" className='boton_index_servicios' transform="translate(829.473 1133)">
                            <g
                                transform="matrix(1, 0, 0, 1, -664.66, -199.13)"
                                filter="url(#Background)"
                            >
                                <path
                                id="Background-2"
                                data-name="Background"
                                d="M1489,1951.749c0-10.079,10.287-18.25,22.978-18.25h222.6c12.691,0,22.978,8.171,22.978,18.25v36.5c0,10.079-10.287,18.25-22.978,18.25h-222.6c-12.69,0-22.978-8.171-22.978-18.25Z"
                                transform="translate(-824.34 -1734.37)"
                                fill="#bf1f60"
                                />
                            </g>
                            <text
                                id="Conoce_todos_los_servicios"
                                data-name="Conoce todos  los servicios"
                                transform="translate(51.369 10.127)"
                                fill="#f8f8f8"
                                fontSize={20}
                                fontFamily="HindMadurai-Bold, Hind Madurai"
                                fontWeight={700}
                                letterSpacing="0.005em"
                            >
                                <tspan x="20.897" y={20}>
                                Conoce todos
                                </tspan>
                                <tspan x="25.477" y={43} xmlSpace="preserve">
                                {" "}
                                los servicios
                                </tspan>
                            </text>
                        </g>
                    </a> */}
                    {/* fin - boton */}
                    
                    <g id="Grupo_122" data-name="Grupo 122">
                    <line
                        id="Línea_4"
                        data-name="Línea 4"
                        x2={162}
                        transform="translate(526.5 982.5)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8"
                        data-name="Elipse 8"
                        transform="translate(688 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    <g
                        id="Elipse_9"
                        data-name="Elipse 9"
                        transform="translate(511 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    </g>
                    <g id="Grupo_123" data-name="Grupo 123" transform="translate(349)">
                    <line
                        id="Línea_4-2"
                        data-name="Línea 4"
                        x2={162}
                        transform="translate(526.5 982.5)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8-2"
                        data-name="Elipse 8"
                        transform="translate(688 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-2"
                        data-name="Elipse 9"
                        transform="translate(511 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    </g>
                    <g id="Grupo_124" data-name="Grupo 124" transform="translate(708)">
                    <line
                        id="Línea_4-3"
                        data-name="Línea 4"
                        x2={162}
                        transform="translate(526.5 982.5)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    <g
                        id="Elipse_8-3"
                        data-name="Elipse 8"
                        transform="translate(688 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-3"
                        data-name="Elipse 9"
                        transform="translate(511 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    </g>
                    <g id="Grupo_125" data-name="Grupo 125" transform="translate(623 185)">
                    <g
                        id="Elipse_8-4"
                        data-name="Elipse 8"
                        transform="translate(946 788)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-4"
                        data-name="Elipse 9"
                        transform="translate(511 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <circle cx={8} cy={8} r={8} stroke="none" />
                        <circle cx={8} cy={8} r="6.5" fill="none" />
                    </g>
                    <path
                        id="Trazado_1251"
                        data-name="Trazado 1251"
                        d="M962,796h97.453s77.5,13.57,76.922,91.857-68.754,94.748-68.754,94.748H525.547"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    </g>
                    <g id="Grupo_126" data-name="Grupo 126" transform="translate(-352.689 186)">
                    <g
                        id="Elipse_8-5"
                        data-name="Elipse 8"
                        transform="translate(685.378 788)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <ellipse cx={8} cy={8} rx={8} ry={8} stroke="none" />
                        <ellipse cx={8} cy={8} rx="6.5" ry="6.5" fill="none" />
                    </g>
                    <g
                        id="Elipse_9-5"
                        data-name="Elipse 9"
                        transform="translate(1120.379 974)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    >
                        <ellipse cx={8} cy={8} rx={8} ry={8} stroke="none" />
                        <ellipse cx={8} cy={8} rx="6.5" ry="6.5" fill="none" />
                    </g>
                    <path
                        id="Trazado_1251-2"
                        data-name="Trazado 1251"
                        d="M699.925,796H602.472s-77.5,13.57-76.922,91.857S594.3,982.605,594.3,982.605h542.075"
                        transform="translate(-14.547)"
                        fill="none"
                        stroke="#707070"
                        strokeWidth={3}
                    />
                    </g>
                </g>
            </svg>

            <div className="servicios-button" style={{display:"flex", justifyContent:"center"}}>
                <WavyLink direction={direction ? "up" : "down"} to="/servicios" color={direction ? "#BF1F60" : "#2A79B0"}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    style={{width:"100%", height:"310px"}}
                    viewBox="0 0 1604.068 242.133"
                >
                    <defs>
                        {/* inicio - color boton */}
                        <filter
                            id="Background"
                            x="609.662"
                            y="169.133"
                            width="358.553"
                            height={163}
                            filterUnits="userSpaceOnUse"
                        >
                        <feOffset dx={-10} dy={15} input="SourceAlpha" />
                        <feGaussianBlur stdDeviation={15} result="blur" />
                        <feFlood floodOpacity="0.302" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                        </filter>
                        {/* fin - color boton */}
                    </defs>
                    <g
                        id="Grupo_199"
                        data-name="Grupo 199"
                        transform="translate(-156.81 -933.867)"
                    >

                        {/* inicio - boton */}
                        <a href="/servicios">
                            <g id="btn-primary" className='boton_index_servicios' transform="translate(829.473 1133)">
                                <g
                                    transform="matrix(1, 0, 0, 1, -664.66, -199.13)"
                                    filter="url(#Background)"
                                >
                                    <path
                                    id="Background-2"
                                    data-name="Background"
                                    d="M1489,1951.749c0-10.079,10.287-18.25,22.978-18.25h222.6c12.691,0,22.978,8.171,22.978,18.25v36.5c0,10.079-10.287,18.25-22.978,18.25h-222.6c-12.69,0-22.978-8.171-22.978-18.25Z"
                                    transform="translate(-824.34 -1734.37)"
                                    fill="#bf1f60"
                                    />
                                </g>
                                <text
                                    id="Conoce_todos_los_servicios"
                                    data-name="Conoce todos  los servicios"
                                    transform="translate(51.369 10.127)"
                                    fill="#f8f8f8"
                                    fontSize={20}
                                    fontFamily="HindMadurai-Bold, Hind Madurai"
                                    fontWeight={700}
                                    letterSpacing="0.005em"
                                >
                                    <tspan x="20.897" y={20}>
                                    Conoce todos
                                    </tspan>
                                    <tspan x="25.477" y={43} xmlSpace="preserve">
                                    {" "}
                                    los servicios
                                    </tspan>
                                </text>
                            </g>
                        </a>
                        {/* fin - boton */}
                    </g>
                </svg>
                </WavyLink>
            </div>
        </div>
    );
};

export default Services;